<template>
	<div class="modal fade" ref="modal" data-backdrop="static">
		<div v-if="DadosDoContrato != null" class="modal-dialog modal-lg">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title pull-left">
						DIMENCIONAMENTO DA EMPRESA
					</h4>
					<div class="pull-right">
						<button
							class="btn btn-default btn-xs"
							data-dismiss="modal"
						>
							<i class="fa fa-close"></i>
							Cancelar
						</button>
						<button
							@click="SalvarMapeamento"
							class="btn btn-primary btn-xs"
						>
							<i class="fa fa-save"></i>
							Salvar
						</button>
					</div>
				</div>
				<div class="modal-body no-padding">
					<dados-empresa
						:dataIn="DadosDoContrato.dados_empresa"
						:AtividadePrincipal="
							DadosDoContrato.atividade_principal_cnpj
						"
						@setDataHeader="setDataHeader"
					/>

					<div class="col-sm-12">
						<ul class="nav nav-pills">
							<li
								v-for="(setor, index) in OptionsSetor"
								:key="index"
								@click="active = setor.value"
								:class="active == setor.value ? 'active' : ''"
							>
								<a>{{ setor.label.toUpperCase() }}</a>
							</li>
						</ul>
						<item-setor
							:dataIn="PegarInformacoesDoSetor"
							@iniciarSetor="iniciarSetor"
						/>
						<br />
					</div>

					<br />
					<div class="clearfix"></div>
					<!-- <pre>{{DadosDoContrato}}</pre> -->
				</div>
				<calculo-cnae-sst
					ref="CalculoCnaeSst"
					:dadosDaEmpresa="DadosDoContrato"
					:totalFunc="totalDeFuncionarios"
					@setDadosTecnicos="setDadosTecnicos"
					@setAtividadePrincipal="setAtividadePrincipal"
				/>
			</div>
		</div>
	</div>
</template>
<script>
	import DadosEmpresa from './components/DadosEmpreas.vue';
	import itemSetor from './components/itemSetor/index.vue';
	import CalculoCnaeSst from './components/CalculoCNAEeSST/index.vue';
	import {
		ResetContrato,
		OptionsSetor,
		ResetMapeamento,
	} from '../../reset.js';

	export default {
		components: {
			DadosEmpresa,
			itemSetor,
			CalculoCnaeSst,
		},
		data() {
			return {
				active: OptionsSetor[0].value,
				DadosDoContrato: JSON.parse(JSON.stringify(ResetContrato)),
				OptionsSetor: this.$clone(OptionsSetor),
			};
		},
		computed: {
			PegarInformacoesDoSetor() {
				const ItemSetor = this.DadosDoContrato.mapeamento.find(
					(item) => item.setor == this.active
				);
				if (ItemSetor == undefined) return null;
				else return ItemSetor;
			},
			totalDeFuncionarios() {
				return this.DadosDoContrato.mapeamento.reduce((acc, item) => {
					acc += parseInt(
						item.funcoes.reduce((accItem, cargo) => {
							accItem +=
								parseInt(cargo.feminino) +
								parseInt(cargo.masculino);
							return accItem;
						}, 0)
					);
					return acc;
				}, 0);
			},
		},
		methods: {
			iniciarSetor() {
				let newMapeamento = this.$clone(ResetMapeamento);
				newMapeamento.setor = this.active;
				this.DadosDoContrato.mapeamento.push(newMapeamento);
			},
			setDataHeader(data) {
				this.DadosDoContrato.atividade_principal =
					data.atividade_principal;
				this.DadosDoContrato.atividade_principal_cnpj =
					data.atividade_principal;
				this.DadosDoContrato.atividades = this.$clone(data.atividades);
				this.$refs.CalculoCnaeSst.selectCnae(data.atividade_principal);
			},
			setDadosTecnicos(val) {
				this.DadosDoContrato.dados_tecnicos = val;
			},
			setAtividadePrincipal(val) {
				this.DadosDoContrato.atividade_principal = val;
			},
			SalvarMapeamento() {
				if (this.DadosDoContrato.dados_empresa.cnpj == '') {
					this.$msg.warning('Defina um cliente antes de salvar!');
					return;
				}
				if (this.DadosDoContrato.atividade_principal == '') {
					this.$msg.warning('Defina uma atividade antes de salvar!');
					return;
				}
				if (this.totalDeFuncionarios == 0) {
					this.$msg.warning('É nescessário ao menos um funcionário!');
					return;
				}

				const sData = this.$clone(this.DadosDoContrato);
				sData.total_funcionarios = this.totalDeFuncionarios;

				this.$wbs.send(
					'private-save-dimencionamento',
					sData,
					(resp) => {
						console.log(resp);
					}
				);
			},
			open(data = null) {
				if (data == null)
					this.DadosDoContrato = this.$clone(ResetContrato);
				else this.DadosDoContrato = this.$clone(data);

				setTimeout(() => {
					$(this.$refs.modal).modal('show');
				}, 100);

				// if(this.assets.grau_de_risco != null){
				//   this.enable = true
				//   setTimeout(e=> {

				//   }, 100)
				// }else{
				//   setTimeout(this.open, 100)
				// }
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/sst/seguranca/components/dimencionamento/index.vue